import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteInitiativeCommentRequest = {
	id: number;
	initiativeId: number;
};

export const deleteInitiativeComment = createDeleteEndpoint<DeleteInitiativeCommentRequest>(
	({ id, initiativeId }) => `/api/v3/initiatives/${initiativeId}/comments/${id}`
);
